// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SetAlertPolicyQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  membershipId: Types.Scalars["ID"]["input"];
}>;

export type SetAlertPolicyQuery = {
  __typename?: "GraphqlQuery";
  getAlertPolicies: Array<{
    __typename?: "AlertPolicy";
    id: string;
    policyName: string;
  }>;
  getOrganizationMembershipDetails: {
    __typename?: "OrganizationMembership";
    id: string;
    alertPolicy: { __typename?: "AlertPolicy"; id: string; policyName: string };
  };
};

export const SetAlertPolicyDocument = gql`
  query SetAlertPolicy($organizationSlug: ID!, $membershipId: ID!) {
    getAlertPolicies(organizationSlug: $organizationSlug) {
      id
      policyName
    }
    getOrganizationMembershipDetails(membershipId: $membershipId) {
      id
      alertPolicy {
        id
        policyName
      }
    }
  }
`;

/**
 * __useSetAlertPolicyQuery__
 *
 * To run a query within a React component, call `useSetAlertPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetAlertPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetAlertPolicyQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useSetAlertPolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    SetAlertPolicyQuery,
    SetAlertPolicyQueryVariables
  > &
    (
      | { variables: SetAlertPolicyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SetAlertPolicyQuery, SetAlertPolicyQueryVariables>(
    SetAlertPolicyDocument,
    options,
  );
}
export function useSetAlertPolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SetAlertPolicyQuery,
    SetAlertPolicyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SetAlertPolicyQuery, SetAlertPolicyQueryVariables>(
    SetAlertPolicyDocument,
    options,
  );
}
// @ts-ignore
export function useSetAlertPolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SetAlertPolicyQuery,
    SetAlertPolicyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SetAlertPolicyQuery,
  SetAlertPolicyQueryVariables
>;
export function useSetAlertPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SetAlertPolicyQuery,
        SetAlertPolicyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SetAlertPolicyQuery | undefined,
  SetAlertPolicyQueryVariables
>;
export function useSetAlertPolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SetAlertPolicyQuery,
        SetAlertPolicyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SetAlertPolicyQuery,
    SetAlertPolicyQueryVariables
  >(SetAlertPolicyDocument, options);
}
export type SetAlertPolicyQueryHookResult = ReturnType<
  typeof useSetAlertPolicyQuery
>;
export type SetAlertPolicyLazyQueryHookResult = ReturnType<
  typeof useSetAlertPolicyLazyQuery
>;
export type SetAlertPolicySuspenseQueryHookResult = ReturnType<
  typeof useSetAlertPolicySuspenseQuery
>;
export type SetAlertPolicyQueryResult = Apollo.QueryResult<
  SetAlertPolicyQuery,
  SetAlertPolicyQueryVariables
>;
